/* eslint-disable @typescript-eslint/only-throw-error */
import { getFirstAccessibleRoute } from '@/features/auth/access-control/getFirstAccessibleChild';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: ({ context, location }) => {
    if (location.pathname === '/') {
      throw redirect({ to: getFirstAccessibleRoute(context.perms) ?? '/forbidden', replace: true });
    }
  },
  component: () => <Outlet />,
});
